
 
import request from '@/utils/request'
import qs from 'qs'
 
/**
 * 登录接口封装
 */
const host = 'https://api.100xsys.cn'
// const host = 'https://srvms.100xsys.cn'
const website = 'PCWS202209050001'
const no = 'yiqipao'
export function getXianZhuang (data) {
  // 返回一个promise对象
  return request({
    url: `${host}/fyzhmd/select/srvcosvc_policy_info_user_select`,
    method: 'POST',
    data: data
  })
}
export function getJianBao (data) {
  // 返回一个promise对象
  return request({
    url: `${host}/daq/select/srvdaq_cms_content_jianbao_select?srvdaq_cms_content_jianbao_select`,
    method: 'POST',
    data: data
  })
}
export function getListData (data,appName,serviceName) {
  // 返回一个promise对象
  return request({
    url: `${host}/${appName}/select/${serviceName}?${serviceName}`,
    method: 'POST',
    data: data
  })
}
export function login (data) {
  // 返回一个promise对象
  return request({
    url: `${host}/sso/operate/srvuser_login`,
    method: 'POST',
    data: data
  })
}
export function friendLinks (data) {
  // 返回一个promise对象
  return request({
    url: `${host}/daq/select/srvcms_friend_links_select`,
    method: 'POST',
    data: data
  })
}
export function multi (data,app) {
  // 返回一个promise对象
  return request({
    url: `${host}/${app}/multi/select/`,
    method: 'POST',
    data: data
  })
}

export function getV2 (data,app) {
  // 返回一个promise对象
  return request({
    url: `${host}/${app}/select/srvsys_service_columnex_v2_select`,
    method: 'POST',
    data: data
  })
}
export function getWebSiteConfig () {
  // 返回一个promise对象
  let app = 'daq'
  let req = {
		"serviceName": "srvdaq_pc_website_cfg_select",
		"colNames": [
			"*"
		],
		"condition": [
			{
				"colName": "website_no",
				"ruleType": "eq",
				"value": website
			}
		],
		"page": {
			"pageNo": 1,
			"rownumber": 999
		},
		"order": []
	}
  return request({
    url: `${host}/${app}/select/srvdaq_pc_website_cfg_select?${no}`,
    method: 'POST',
    data: req
  })
}
export function getWebSiteCategoryConfig () {
  // 返回一个promise对象
  let app = 'daq'
  let req = {
		"serviceName": "srvdaq_pc_website_category_select",
		"colNames": [
			"*"
		],
		"condition": [
			{
				"colName": "website_no",
				"ruleType": "eq",
				"value": website
			},
      {
				"colName": "is_view",
				"ruleType": "eq",
				"value": '是'
			}
		],
		"page": {
			"pageNo": 1,
			"rownumber": 999
		},
    "treeData":true,
		"order": [{"colName":"seq","orderType":"asc"}]
	}
  return request({
    url: `${host}/${app}/select/srvdaq_pc_website_category_select_yiqipao/`,
    method: 'POST',
    data: req
  })
}



export function getWebSitePcCarousel () {
  // 返回一个promise对象
  let app = 'daq'
  let req = {
		"serviceName": "srvdaq_pc_carousel_select",
		"colNames": [
			"*"
		],
		"condition": [
			{
				"colName": "website_no",
				"ruleType": "eq",
				"value": website
			},{
				"colName": "is_view",
				"ruleType": "eq",
				"value": '是'
			}
		],
		"page": {
			"pageNo": 1,
			"rownumber": 999
		},
    "treeData":true,
		"order": [{"colName":"seq","orderType":"asc"}]
	}
  return request({
    url: `${host}/${app}/select/srvdaq_pc_carousel_select/`,
    method: 'POST',
    data: req
  })
}

